import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { POST_MCP_REQUEST_API } from '../../constants/central-api';
import { submitLogToBugsnag } from '../log';

export default async function request_mcp_api_call(
  mcp_name: string,
  mcp_description: string,
  mcp_priority: string
) {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const isWhiteLabel = store.getState().UI?.isWhiteLabel;
    let sellerToken: string;
    if (isWhiteLabel) {
      sellerToken = accessToken?.currentWhiteLabelSellerToken;
    } else {
      sellerToken = accessToken?.sellerToken;
    }

    const requestInfo: RequestInfo = {
      url: POST_MCP_REQUEST_API(shopSlug),
      method: 'POST',
      body: JSON.stringify({
        mcp_name: mcp_name,
        description: mcp_description,
        priority_level: mcp_priority,
      }),
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'REQUEST_MCP';
    const customMsg = 'MCP Request Sent Successfully.';

    const res: any = await asyncHandler(requestInfo, actionType, customMsg);

    const response = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return true;
    } else {
      return false;
    }
  } catch (exception) {
    console.log('Error during authentication request');
    submitLogToBugsnag('error', `${exception}`);
    return false;
  }
}
